import { UtilsHelper } from "app/core/utilsHelper";

export const errorHandler = (error) => {
  // Please do the neccessary error handling mechanism
  // AlertHelper.showError(error);
  if (401 === error.response.status) {
    UtilsHelper.logout();
  }
};
